module.exports = __webpack_public_path__ + "img/card_informe_monitoria_estudiantes.b36988d9.svg";